"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mountWithRouterAndThemeProvider = exports.getProp = void 0;
exports.mountWithTheme = mountWithTheme;
exports.shallowMountWithThemeAndRouter = exports.setupEnzymeAdapter = exports.mountWithThemeProvider = void 0;
exports.shallowWithTheme = shallowWithTheme;
var _react = _interopRequireDefault(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _config = _interopRequireDefault(require("@trs/config"));
var _styledComponents = require("styled-components");
var _reactRouter = require("react-router");
var _enzymeAdapterReact = _interopRequireDefault(require("@wojtekmaj/enzyme-adapter-react-17"));
var _enzyme = _interopRequireWildcard(require("enzyme"));
var _objects = require("../objects");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var theme = _config["default"].theme;
var setupEnzymeAdapter = exports.setupEnzymeAdapter = function setupEnzymeAdapter() {
  _enzyme["default"].configure({
    adapter: new _enzymeAdapterReact["default"]()
  });
};
var mountWithThemeProvider = exports.mountWithThemeProvider = function mountWithThemeProvider(children) {
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme.base
  }, children);
};
var mountWithRouterAndThemeProvider = exports.mountWithRouterAndThemeProvider = function mountWithRouterAndThemeProvider(children) {
  return (
    // eslint-disable-next-line react/prop-types
    function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$routeEntries = _ref.routeEntries,
        routeEntries = _ref$routeEntries === void 0 ? ['/'] : _ref$routeEntries;
      return /*#__PURE__*/_react["default"].createElement(_reactRouter.MemoryRouter, {
        initialEntries: routeEntries
      }, /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme.base
      }, children));
    }
  );
};

/* eslint-disable */
function mountWithTheme(child) {
  return (0, _enzyme.mount)(child, {
    // eslint-disable-next-line react/prop-types
    wrappingComponent: function wrappingComponent(_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme.base
      }, children);
    }
  });
}
function shallowWithTheme(child) {
  return (0, _enzyme.shallow)(child, {
    // eslint-disable-next-line react/prop-types
    wrappingComponent: function wrappingComponent(_ref3) {
      var children = _ref3.children;
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme.base
      }, children);
    }
  });
}
var shallowMountWithThemeAndRouter = exports.shallowMountWithThemeAndRouter = function shallowMountWithThemeAndRouter(tree) {
  var context = (0, _enzyme.shallow)(/*#__PURE__*/_react["default"].createElement(_reactRouter.MemoryRouter, {
    initialEntries: ['/random']
  })).instance().context.context;
  context = R.path(['context'], (0, _enzyme.shallow)(/*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme.base
  }), {
    context: context
  }).instance());
  return (0, _enzyme.shallow)(tree, {
    context: context,
    childContextTypes: _styledComponents.ThemeProvider.childContextTypes // Needed so child components receive the theme prop
  });
};
/* eslint-disable */

var getProp = exports.getProp = function getProp(wrapper, selector, prop) {
  if (!wrapper) return null;
  var node = selector ? wrapper.find(selector) : wrapper;
  if ((0, _objects.isBlank)(node) || !R.prop('props', node)) return null; // no selector found
  if (!prop) return node.props(); // return all props if no prop name
  return R.prop(prop, node.props());
};